module.exports = __webpack_public_path__ + "static/media/paf_scholarship_package_2016_-_chicago_chapter_-_criteria___application.8bb3a636.pdf";